import type { AxiosResponse } from 'axios'
import type {
  CheckFileDeletableModel,
  OtherProductAddModel,
  OtherProductSearchParams,
  QueryOtherProductsModel,
  ResponseTransaction,
  TransactionDetails,
} from './model/sendMailModel'

import { bffHTTP } from '@/utils/http/axios'
import { handleAPIException } from '@/utils/exception'
import { errorMessage } from '@/utils/util'
import { getMessage } from '@/utils/message'
import { ApiResponseStatusEnum, HTTPMethodsEnum } from '@/enums'

enum Api {
  TransactionDetails_API = '/transactions',
  DocumentInputHistories_API = '/document_input_histories',
}

/**
 * @description 取引詳細取得
 * @returns
 */
export async function getTransactionDetails(
  transactionSequence: number
): Promise<TransactionDetails | undefined> {
  try {
    const url: string = Api.TransactionDetails_API + '/' + transactionSequence

    const response: AxiosResponse<ResponseTransaction, any> = await bffHTTP({
      method: 'GET',
      url: url,
    })

    handleAPIException(response)
    return response.data.detail[0]
  } catch (error) {
    console.log('getTransactionDetails error', error)
    return {} as TransactionDetails
  }
}

/**
 * @description 利用者別他社商品取得API
 * @params 検索条件
 */
export async function getOtherProducts(
  params: OtherProductSearchParams
): Promise<QueryOtherProductsModel> {
  try {
    const response: AxiosResponse<QueryOtherProductsModel, any> = await bffHTTP({
      method: 'GET',
      url: `/products/other`,
      params,
    })

    handleAPIException(response)

    return response.data
  } catch (error) {
    console.log('getOtherProducts error', error)
    return {} as QueryOtherProductsModel
  }
}

/**
 * @description 利用者別他社商品追加
 * @params 他社商品
 */
export async function postAddOtherProduct(
  params: OtherProductAddModel
): Promise<boolean> {
  try {
    const response: AxiosResponse<void, any> = await bffHTTP({
      method: HTTPMethodsEnum.POST,
      url: `/receipt`,
      data: params,
    })

    handleAPIException(response)

    if (response.status === ApiResponseStatusEnum.SUCCESSFUL_STATUS) {
      errorMessage(getMessage('IF0001'), 'success')
    }

    return response.status === ApiResponseStatusEnum.SUCCESSFUL_STATUS
  } catch (error) {
    console.warn('postAddOtherProduct error', error)
    return false
  }
}

/**
 * @description 取り込み履歴削除API
 * @params  transaction_sequence 取引シーケンス, product_id　商品ID
 */
export async function postDeleteOtherProduct(
  transaction_sequence: string,
  product_id: number
): Promise<void> {
  try {
    const response: AxiosResponse<void, any> = await bffHTTP({
      method: 'DELETE',
      url:
        Api.DocumentInputHistories_API +
        '/' +
        transaction_sequence +
        '?product_id=' +
        product_id,
    })

    handleAPIException(response)

    if (response.status === 200) {
      errorMessage(getMessage('IF0001'), 'success')
    }
  } catch (error) {
    console.log('postDeleteOtherProduct error', error)
  }
}

/**
 * @description ファイル削除事前チェック API
 * @param documentID
 * @param fileID
 * @returns
 */
export async function checkFileDeletable(file: {
  documentID: number
  fileID: number
}): Promise<CheckFileDeletableModel | undefined> {
  try {
    const response: AxiosResponse<{ detail: CheckFileDeletableModel }, null> =
      await bffHTTP({
        method: 'GET',
        url: '/transactions/transaction_status',
        params: { document_id: file.documentID, file_id: file.fileID },
      })

    handleAPIException(response)

    return response.data.detail
  } catch (error) {
    console.error(error)
    return undefined
  }
}
